"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["anchorEl", "className", "classes", "children", "dataMetrics", "handleOnKeyDown", "id", "MenuListProps", "MenuRef", "onClose", "open", "popperPlacement", "subnav", "width", "onMouseEnter"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = function useStyles(_ref) {
  var classes = _ref.classes;
  return (0, _styles.makeStyles)(function (theme) {
    return {
      paper: _objectSpread({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius / 2,
        boxShadow: theme.shadows[9]
      }, classes.paper && _objectSpread({}, classes.paper)),
      popper: {
        outline: 0,
        position: 'absolute !important',
        // MaterialUI v4 fix
        zIndex: theme.zIndex.modal + 1
      },
      subnav: {
        transform: "translateY(-".concat(theme.spacing(1), "px)")
      }
    };
  })();
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_menu'
  },
  MenuListProps: {}
};
var StyledMenu = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var anchorEl = _ref2.anchorEl,
    className = _ref2.className,
    classes = _ref2.classes,
    children = _ref2.children,
    dataMetrics = _ref2.dataMetrics,
    handleOnKeyDown = _ref2.handleOnKeyDown,
    id = _ref2.id,
    MenuListProps = _ref2.MenuListProps,
    MenuRef = _ref2.MenuRef,
    onClose = _ref2.onClose,
    open = _ref2.open,
    popperPlacement = _ref2.popperPlacement,
    subnav = _ref2.subnav,
    width = _ref2.width,
    onMouseEnter = _ref2.onMouseEnter,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var styles = useStyles({
    classes: classes
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!open) {
      setAnchor(null);
    }
  }, [open]);
  var inlineStyles = _objectSpread({}, width && {
    width: width
  });
  var isDescendant = function isDescendant(parent, event) {
    if (!parent) return false;
    var path = event.composedPath();
    return path.some(function (current) {
      return current === parent;
    });
  };
  var ClickAwayListener = function ClickAwayListener(event) {
    if (!anchorEl && !anchor) return;
    if (isDescendant(anchorEl, event)) {
      if (!anchor) {
        setAnchor(anchorEl);
        return;
      }
      if (anchorEl === null) {
        setAnchor(null);
      }
    }
    if (open) {
      onClose(event);
    }
  };
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({
    "aria-label": "menu popup",
    anchorEl: anchorEl,
    className: styles.popper,
    "data-metrics": mergedDataMetrics.root,
    id: subnav ? "subnav-".concat(id) : id,
    keepMounted: true // ACCESSIBILITY we need to keep it mounted in order for the focus to work properly
    ,
    onMouseEnter: onMouseEnter,
    open: open,
    placement: popperPlacement,
    tabIndex: "0",
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    style: inlineStyles,
    className: (0, _classnames["default"])(styles.paper, (0, _defineProperty2["default"])({}, styles.subnav, subnav), className)
  }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: ClickAwayListener
  }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], (0, _extends2["default"])({}, MenuListProps, {
    "aria-busy": "true",
    onKeyDown: handleOnKeyDown,
    ref: MenuRef,
    role: "menu",
    variant: "menu"
  }), children))));
});
StyledMenu.defaultProps = defaultProps;
StyledMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Element to anchor/attach the Menu to. Menu will render underneath the passed anchor element.
   */
  anchorEl: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * Children are usually MenuItems.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * Additional classes to apply to the element.
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Function to handle the differnet types of key presses
   */
  handleOnKeyDown: _propTypes["default"].func.isRequired,
  /**
   * For accessibility you must pass in an id and add 'aria-controls=ID_NAME' in the element used to open the menu.
   * `(Ex: <button aria-controls="my-popup-menu"></Menu id="my-popup-menu"></Menu>)`
   */
  id: _propTypes["default"].string.isRequired,
  /**
   * Properties applied to the MUI MenuList element.
   */
  MenuListProps: _propTypes["default"].object,
  /**
   * Need to pass the menu ref in order to handle the focus
   */
  MenuRef: _propTypes["default"].object,
  /**
   * Function callback to invoke when Menu is closed.
   */
  onClose: _propTypes["default"].func.isRequired,
  /**
   * @ignore
   */
  onMouseEnter: _propTypes["default"].func.isRequired,
  /**
   * If `true`, Menu will render on the screen.
   * Usually this property is tied to some piece of state or cast the anchorEl as a boolean value: Boolean(anchorEl).
   */
  open: _propTypes["default"].bool.isRequired,
  /**
   * Object that lets the popper know where to trigger
   */
  popperPlacement: _propTypes["default"].string.isRequired,
  /**
   * If `true`, the Menu will render as a subnav/nested Menu.
   * The Menu will render left or right of the anchor menu
   * instead of underneath the anchor element.
   */
  subnav: _propTypes["default"].bool,
  /**
   * A Fixed width of Menu in pixels. Ex: `200px`.
   */
  width: _propTypes["default"].string
} : {};
var _default = StyledMenu;
exports["default"] = _default;